// dependencies
import { format } from "date-fns";
import React from "react";

// components
import FilterChips from "../../../components/FilterChips";
import { Filter } from "../../../components/FilterChips/FilterChips";
// config
import { CompanyFeedbackFilter } from "./CompanyFeedbackFilters";

const convertFiltersToReadableList = (filters: CompanyFeedbackFilter) => {
	const readableList: Filter[] = [];

	Object.keys(filters).forEach((filterKey) => {
		const filter = filters[filterKey];

		if (filterKey === "author") {
			readableList.push({
				id: "author",
				type: "single-employee",
				label: "Author",
				value: { name: filter.label, id: filter.value },
			} as Filter);
		}

		if (filterKey === "subject") {
			readableList.push({
				id: "subject",
				type: "single-employee",
				label: "Subject",
				value: { name: filter.label, id: filter.value },
			} as Filter);
		}

		if (filterKey === "sharedWith") {
			readableList.push({
				id: "sharedWith",
				type: "string",
				label: "Shared With",
				value: filter.label,
			} as Filter);
		}

		if (filterKey === "dateBefore") {
			readableList.push({
				id: "dateBefore",
				type: "string",
				label: "Date Before",
				value: format(filter, "yyyy-MM-dd"),
			} as Filter);
		}

		if (filterKey === "dateAfter") {
			readableList.push({
				id: "dateAfter",
				type: "string",
				label: "Date After",
				value: format(filter, "yyyy-MM-dd"),
			} as Filter);
		}

		if (filterKey === "responseToRequest") {
			readableList.push({
				id: "responseToRequest",
				type: "string",
				label: "Was Requested",
				value: filter.label,
			} as Filter);
		}

		if (filterKey === "hashTags") {
			readableList.push({
				id: "hashTags",
				type: "string",
				label: "Hashtags",
				value: filter.map((hashtag) => hashtag.label),
			} as Filter);
		}
	});
	return readableList;
};

type ReadableCompanyFeedbackFilterChipsProps = {
	filters: CompanyFeedbackFilter;
	setFilters: (newFilters) => void;
};

const ReadableCompanyFeedbackFilterChips = ({ filters, setFilters }: ReadableCompanyFeedbackFilterChipsProps) => {
	const convertedFilters = convertFiltersToReadableList(filters);

	if (convertedFilters.length === 0) {
		return null;
	}

	return (
		<div>
			<FilterChips
				filters={convertedFilters}
				label="Filters applied: "
				onDeleteFilter={(id) => {
					const currentFilters = { ...filters };
					delete currentFilters[id];
					setFilters({ ...currentFilters });
				}}
			/>
		</div>
	);
};

export default ReadableCompanyFeedbackFilterChips;
